import React from 'react'
import teamphoto from '../../assets/Whoweare/group photo.jpg'
import '../../styles/WhoWeAreTeam.css';
function WhoWeAreTeam() {
  return (
    <div className='teamWriteUp'>
    <img src={teamphoto} alt='team' className='teamPhoto'></img>
      <p>
        Introducing JS Property, a premier real estate partnership in Singapore 
        founded by industry veterans Simon Yio and Jen Lee. With over 30 years of 
        combined experience, we specialize in Asset Progression, Portfolio Management, 
        Property Investment, and Property Transactions.<br />
        
        By leveraging data-driven insights, we offer comprehensive market analyses, 
        enabling our clients to make informed decisions in Singapore's dynamic property 
        landscape. <br />
        Both Simon and Jen's experiences as business owners and founders of local 
        companies also sets JS Property apart. Our entrepreneurial background enables 
        us to understand exactly what investors are seeking as well as identify lucrative 
        opportunities that others might overlook.</p>
        <p>
        At JS Property, we are committed to delivering personalized strategies that align 
        with your unique goals. Our deep industry knowledge and extensive networks empower 
        us to provide unparalleled service, ensuring your real estate journey is both 
        rewarding and seamless.<br />
        Whether you're looking to enhance your property portfolio, invest in high-value 
        assets, or navigate complex transactions, JS Property's distinctive edge and unique 
        blend of business acumen and data-driven market insights guides you beyond traditional 
        real estate services. We are your trusted partner in achieving real estate excellence 
        in Singapore.
      </p>
    </div>
  )
}

export default WhoWeAreTeam
